module.exports = __webpack_public_path__ + "static/img/goodness6.6f08f6d6.png";